import React from 'react';
import styles from './SectionTitle.module.scss';

export default function SectionTitle({ children }) {
  return <h2 className={styles.title}>{children}</h2>;
}
